export const login = {
  sendSmsVerifyCode: '/api/insureadmin/commonService/sendSmsVerifyCode',
  register: '/api/insureadmin/customerIcpService/register',
  login: '/api/insureadmin/customerIcpService/login',
  logout: '/api/insureadmin/customerIcpService/logout',
  myPublish: '/api/insureadmin/customerIcpService/myPublish',
  publish: '/api/insureadmin/customerIcpService/publish',
  onlyUpload: '/api/insureadmin/customerIcpService/onlyUpload',
  verifyCode: '/api/insureadmin/customerIcpService/verifyCode'
}